var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTheme = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.0003C2 6.47728 6.47728 2 12.0003 2V12.0003V22.0006C6.47728 22.0006 2 17.5233 2 12.0003ZM12.0003 0C5.37271 0 0 5.37271 0 12.0003C0 18.6278 5.37271 24.0006 12.0003 24.0006C18.6278 24.0006 24.0006 18.6278 24.0006 12.0003C24.0006 5.37271 18.6278 0 12.0003 0Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTheme);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Theme.029d452754f29aaaf2f98daf7a641b65.svg";